
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79.487 40.887c0 21.794-17.681 39.463-39.493 39.463S.5 62.68.5 40.887 18.182 1.425 39.994 1.425s39.493 17.668 39.493 39.462z","stroke":"#1D1D1D"}}),_c('path',{attrs:{"d":"M30.545 46V35.125h-1.53v9.255l-4.965-9.255H21.8V46h1.53v-9.285L28.31 46h2.235zm2.578 0h7.38v-1.32h-5.85v-3.615h5.505v-1.32h-5.505v-3.3h5.85v-1.32h-7.38V46zm7.91 0h1.725l3.165-4.395L49.073 46h1.8l-4.035-5.655 3.765-5.22h-1.725l-2.895 4.02-2.865-4.02h-1.815l3.765 5.28L41.033 46zm13.383 0h1.53v-9.555h3.54v-1.32h-8.61v1.32h3.54V46z","fill":"#1D1D1D"}})])
          )
        }
      }
    